// import React from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { isLoggedIn, userDetails } from "../../../redux/actions/actions";
// import firebase from "../../../firebase/firebase";
// import { Link } from "react-router-dom";
// import styling from "./Navbar.module.css";
// import { BsGraphUp } from "react-icons/bs";
// import { notify, ToastContainer } from "../../Notify/Notify";

// function Navbar() {
//   let loggedIn = useSelector((state) => state.isLogged);
//   const dispatch = useDispatch();

//   let logoutfromGoogle = () => {
//     firebase
//       .auth()
//       .signOut()
//       .then(function () {
//         dispatch(isLoggedIn());
//         dispatch(userDetails({}));
//         console.log("Sign Out SuccessFull");
//       })
//       .catch(function (error) {
//         console.log("Sign Out Error");
//       });
//   };
//   return (
//     <>
//       <div className={styling.Navbar}>
//         <div className={styling.logo}>
//           <h2>
//             <Link to="/">
//               ShopManager <BsGraphUp className={styling.logoIcon} />
//             </Link>
//           </h2>
//         </div>
//         <div className={styling.navbarContent}>
//           {loggedIn ? (
//             <div
//               className={styling.button}
//               onClick={() => {
//                 logoutfromGoogle();
//                 notify("error", "Logged Out Successfully 😐");
//               }}
//             >
//               Logout
//             </div>
//           ) : (
//             <div className={styling.navOptions}>
//               <Link to="/demo" className="btn btn-primary">
//                 <div className={styling.button}>Demo</div>
//               </Link>
//               <Link to="/signin" className="btn btn-primary">
//                 <div className={styling.button}>Sign In</div>
//               </Link>
//             </div>
//           )}
//         </div>
//       </div>
//       <ToastContainer />
//     </>
//   );
// }

// export default Navbar;

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { isLoggedIn, userDetails } from "../../../redux/actions/actions";
import firebase from "../../../firebase/firebase";
import { Link, useLocation } from "react-router-dom";
import styling from "./Navbar.module.css";
import { BsGraphUp } from "react-icons/bs";
import { notify, ToastContainer } from "../../Notify/Notify";

function Navbar({ hideLogin, hideAllOptions }) {
  const loggedIn = useSelector((state) => state.isLogged);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleLogout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch(isLoggedIn());
        dispatch(userDetails({}));
        notify("error", "Logged out successfully 😐");
      })
      .catch(() => {
        notify("error", "Something went wrong. Please try again.");
      });
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <header className={styling.Navbar}>
        <div className={styling.navInner}>
          {/* LEFT: Logo */}
          <div className={styling.logo}>
            <Link to="/" className={styling.logoLink}>
              <span className={styling.logoMark}>
                <BsGraphUp />
              </span>
              <span className={styling.logoText}>ShopManager</span>
            </Link>
          </div>

          {/* RIGHT: Auth / Dashboard */}
          {!hideAllOptions && (
            <div className={styling.navActions}>
              {loggedIn ? (
                <>
                  <Link
                    to="/dashboard"
                    className={`${styling.actionButton} ${styling.actionSecondary}`}
                  >
                    Dashboard
                  </Link>
                  {!hideLogin && (
                    <button
                      type="button"
                      onClick={handleLogout}
                      className={`${styling.actionButton} ${styling.actionPrimary}`}
                    >
                      Logout
                    </button>
                  )}
                </>
              ) : (
                <>
                  <Link
                    to="/demo"
                    className={`${styling.actionButton} ${styling.actionSecondary}`}
                  >
                    Demo
                  </Link>
                  {!hideLogin && (
                    <Link
                      to="/signin"
                      className={`${styling.actionButton} ${styling.actionPrimary}`}
                    >
                      Sign In
                    </Link>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </header>
      <ToastContainer />
    </>
  );
}

export default Navbar;
